import { findIndex, map, forEach } from 'lodash'

export function displayHours(clinic) {
  const dayNames = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]
  const currentDay = dayNames[new Date().getDay()]
  let officeHourIndex = findIndex(clinic.officeHours, (oh) => { return oh.day === currentDay })

  if (officeHourIndex === -1) return null

  let officeHours = clinic.officeHours[officeHourIndex]

  const getNextOpenDay = (dayIndex) => {
    let _offset = dayIndex
    let _indexMax = clinic.officeHours.length

    for( let i = 0; i < _indexMax; i++ ) {
      const _index = (i + _offset)%_indexMax
      const _officeHour = clinic.officeHours[_index]
      if (_officeHour.open) {
        console.log(_officeHour)
        return _index
      }
    }

    return null
  }
  if (!officeHours.open) {
    officeHourIndex = getNextOpenDay(officeHourIndex)

    if (officeHourIndex === null) return null
    return `Closed today, open ${clinic.officeHours[officeHourIndex].day}`
  }

  return `Open today ${officeHours.open} - ${officeHours.close}`
}

export function displayFullHours(clinic, openColor = "text-white", closeColor = 'text-white/50', noteColor = 'text-white/75') {
  const dayNames = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]
  const currentDay = dayNames[new Date().getDay()]
  let officeHourIndex = findIndex(clinic.officeHours, (oh) => { return oh.day === currentDay })

  let officeHourItems = []

  forEach(clinic.officeHours, (coh, index) => {
    const dayKey = `${clinic.slug}-hour-${index}`
    if (coh.open) officeHourItems.push(<tr className={openColor} key={dayKey}><td>{coh.day}</td><td>{coh.open} - {coh.close}</td></tr>)
    else officeHourItems.push(<tr key={dayKey} className={closeColor}><td>{coh.day}</td><td>Closed</td></tr>)

    if (coh.note) officeHourItems.push(<tr key={dayKey+"_note"} className={noteColor}><td colSpan="2" className="pl-2 italic">{coh.note}</td></tr>)
  })

  return (
    <table className="table-auto">
      <tbody>
        { map(officeHourItems, (ohi) => { return ohi }) }
      </tbody>
    </table>
  )
}